import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text, TextArea } from 'informed';

import { Label, PrimaryText } from '../../Typography.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';
import Typeahead from '../../Typeahead.jsx';

import styles from '../../../styles/patientPages/informationHistory/SocialHistory.scss';

import {
  updateSocialHistory,
} from '../../../actions/informationHistoryActions';

type Props = {
  activePatientId: string,
  socialHistory: Object,
  formApi: Object,
  updateSocialHistory: Function,
  print: boolean,
}

type State = {
  editing: bool,
}

class SocialHistoryComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  onCancel = () => {
    this.setState({
      editing: false,
    });
  }

  onSave = () => {
    const { invalid, values } = this.props.formApi.getState();
    if (invalid) {
      return;
    }
    this.props.updateSocialHistory(this.props.activePatientId, values);
    this.setState({
      editing: false,
    });
  }

  onEdit = () => {
    this.setState({
      editing: true,
    });
  }

  render() {
    let {
      location, mother, father, background, otherInfo, summary,
    } = this.props.socialHistory;

    if (this.state.editing) {
      location = <Typeahead field='location' initialValue={location} endpoint='socialHxLocation' />;
      mother = <Text field='mother' initialValue={mother} />;
      father = <Text field='father' initialValue={father} />;
      background = <TextArea field='background' initialValue={background} />;
      otherInfo = <TextArea field='otherInfo' initialValue={otherInfo} />;
      summary = <TextArea field='summary' initialValue={summary} placeholder='Brief social history to be displayed on Patient Summary page' />;
    }

    return (
      <div>
        <table className={styles.socialHistoryTable}>
          <tbody>
            <tr>
              <td><Label>Location:</Label></td>
              <td>{location || '--'}</td>
            </tr>
            <tr>
              <td className={styles.motherName}><Label>{'Mother\'s Name'}:</Label></td>
              <td>{mother || '--'}</td>
            </tr>
            <tr>
              <td><Label>{'Father\'s Name'}:</Label></td>
              <td>{father || '--'}</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.backgroundContainer}>
          <PrimaryText>Background</PrimaryText>
          <div>
            {background || '--'}
          </div>
        </div>

        <div className={styles.otherInfoContainer}>
          <PrimaryText>Other Information</PrimaryText>
          <div>
            {otherInfo || '--'}
          </div>
        </div>

        <div className={styles.summaryContainer}>
          <PrimaryText>Summary</PrimaryText>
          <div>
            {summary || '--'}
          </div>
        </div>

        {!this.props.print
          && (this.state.editing
            ? (
              <div>
                <PrimaryButton onClick={this.onSave}>Save</PrimaryButton>
                <Button onClick={this.onCancel}>Cancel</Button>
              </div>
            ) : (
              <PrimaryButton onClick={this.onEdit}>Edit</PrimaryButton>
            )
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  socialHistory: state.patient.data.socialHistory,
  print: state.patient.print,
});

const mapDispatchToProps = dispatch => ({
  updateSocialHistory:
    (patientId, socialHistory) => dispatch(updateSocialHistory(patientId, socialHistory)),
});

const SocialHistory = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialHistoryComponent);

export default SocialHistory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/SocialHistory.jsx